var _rect, _path, _g, _path2, _path3, _path4, _g2, _path5, _g3, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path0, _g9, _path1, _g0, _path10, _path11, _path12, _path13, _path14, _path15, _g1, _path16, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDebt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 68,
    viewBox: "0 0 91 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1353_32975)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 67.0526,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1353_32975)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 1,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4001 1.37879L45.7338 11.9143C45.1905 12.405 45.1478 13.2432 45.6385 13.7866L47.3802 15.7152C47.8709 16.2586 48.7091 16.3013 49.2525 15.8106L60.9187 5.27508C61.4621 4.78438 61.5048 3.94611 61.0141 3.40275L59.2724 1.47415C58.7817 0.930791 57.9434 0.888096 57.4001 1.37879Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4001 1.37879L45.7338 11.9143C45.1905 12.405 45.1478 13.2432 45.6385 13.7866L47.3802 15.7152C47.8709 16.2586 48.7091 16.3013 49.2525 15.8106L60.9187 5.27508C61.4621 4.78438 61.5048 3.94611 61.0141 3.40275L59.2724 1.47415C58.7817 0.930791 57.9434 0.888096 57.4001 1.37879Z",
    fill: "#D88532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4001 1.37879L45.7338 11.9143C45.1905 12.405 45.1478 13.2432 45.6385 13.7866L47.3802 15.7152C47.8709 16.2586 48.7091 16.3013 49.2525 15.8106L60.9187 5.27508C61.4621 4.78438 61.5048 3.94611 61.0141 3.40275L59.2724 1.47415C58.7817 0.930791 57.9434 0.888096 57.4001 1.37879Z",
    fill: "#D88532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8575 14.3653C49.3482 14.9087 50.1865 14.9514 50.7298 14.4607L53.4497 12.0044L53.1218 12.3006C52.5784 12.7913 51.7401 12.7486 51.2494 12.2052L49.517 10.2868C49.0263 9.74343 49.069 8.90514 49.6123 8.41446L49.9403 8.11829L47.2204 10.5746C46.677 11.0652 46.6343 11.9035 47.125 12.4469L48.8575 14.3653Z",
    fill: "#EFBB6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2624 3.18843C61.7531 3.73179 61.7104 4.57006 61.167 5.06076L48.1156 16.8472L47.7188 16.4078L57.0665 7.96614C57.7909 7.31187 57.8479 6.19418 57.1936 5.4697L56.4369 4.63178C55.7827 3.9073 54.6649 3.85037 53.9404 4.50464L57.6442 1.15988C58.1876 0.669177 59.0258 0.711869 59.5165 1.25524L61.2624 3.18843Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6641 13.793L59.7229 0.19378L59.1764 -0.411316L44.7222 12.6419L44.6641 13.793Z",
    fill: "#EFBB6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 19,
    width: 42,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2684 30.7047C32.3471 28.1021 34.4082 25.9946 37.0084 25.8579C38.19 25.7958 39.1161 24.8197 39.1161 23.6365V19.7927L66.2392 19.7888V23.368C66.2392 24.4148 67.0878 25.2634 68.1347 25.2634C70.49 25.2634 72.3994 27.1729 72.3994 29.5282V61.0954C72.3994 64.1408 69.9306 66.6097 66.8852 66.6097H36.8658C33.7551 66.6097 31.2601 64.0377 31.3541 60.9286L32.2684 30.7047Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1353_32975)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2684 30.7051C32.3471 28.1024 34.4082 25.995 37.0084 25.8583C38.19 25.7962 39.1161 24.82 39.1161 23.6369V22.5245L66.2392 22.5206V23.3683C66.2392 24.4152 67.0878 25.2638 68.1347 25.2638C70.49 25.2638 72.3994 27.1732 72.3994 29.5285V61.0957C72.3994 64.1409 69.9306 66.6098 66.8852 66.6098H36.8658C33.7551 66.6098 31.2601 64.0384 31.3541 60.9289L32.2684 30.7051Z",
    fill: "#AEBCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 22,
    width: 42,
    height: 45
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5738 31.9015C53.5738 29.9204 54.9205 28.1927 56.8418 27.7093C57.6957 27.4944 58.2942 26.7266 58.2942 25.8462V22.922L63.8032 22.7526V24.9377C63.8032 26.2736 64.8732 27.3635 66.209 27.3881L66.8516 27.3998C68.7297 27.4343 70.2342 28.9666 70.2342 30.8451V61.3914C70.2342 62.0473 70.7659 62.579 71.4218 62.579C71.9305 62.579 72.3489 62.1784 72.371 61.6703L72.3967 61.0811C72.4756 64.1305 70.025 66.6456 66.9744 66.6456H31.8926V64.6593L48.4925 64.2564C51.3185 64.1874 53.5738 61.8769 53.5738 59.0499V31.9015Z",
    fill: "#A5B4FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3113 30.9546C54.3451 29.4329 55.5052 28.1737 57.0191 28.0156C57.7328 27.941 58.2619 27.3188 58.2207 26.6024L58.0107 22.9486L64.6184 22.7535V25.5529C64.6184 26.6582 65.5144 27.5542 66.6196 27.5542C69.1065 27.5542 71.1225 29.5702 71.1225 32.057V61.9442C71.1225 62.3373 71.4557 62.6482 71.8479 62.6209C72.1233 62.6018 72.3405 62.379 72.3525 62.1031L72.3967 61.0894C72.4756 64.1391 70.025 66.6536 66.9744 66.6536H31.8926V64.6679L48.6042 64.2618C51.3854 64.1942 53.6224 61.9526 53.6842 59.1713L54.3113 30.9546Z",
    fill: "#5770EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.794 33.9435C77.8301 50.5809 70.9535 57.522 62.5181 57.522C54.0828 57.522 47.2422 46.9674 47.2422 33.9435C47.2422 20.9195 54.0828 10.365 62.5181 10.365C70.9535 10.365 77.7724 20.9195 77.794 33.9435Z",
    fill: "#CCD5FF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3707 42.6542L53.0625 66.6105H71.07L71.5918 65.1176H69.5498C67.8329 65.1176 66.3542 63.9069 66.0157 62.2238L62.3094 43.7931L56.3707 42.6542Z",
    fill: "#240544"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 13,
    width: 31,
    height: 10
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6434 16.4636C37.6745 14.9283 38.9304 13.7013 40.4659 13.7062L64.4267 13.7822C65.9996 13.7872 67.2631 15.0805 67.2314 16.6532L67.1457 20.8962C67.1271 21.8173 66.3735 22.5535 65.4522 22.5506L39.2398 22.4675C38.296 22.4645 37.5379 21.6885 37.557 20.7449L37.6434 16.4636Z",
    fill: "#727272"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M37.6434 16.4635C37.6745 14.9282 38.9304 13.7012 40.4659 13.7061L64.4267 13.782C65.9996 13.787 67.2631 15.0804 67.2314 16.653L67.1457 20.8961C67.1271 21.8172 66.3735 22.5534 65.4522 22.5505L39.2398 22.4674C38.296 22.4644 37.5379 21.6884 37.557 20.7448L37.6434 16.4635Z",
    fill: "#CCD5FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M45.2149 27.0511C53.1931 27.2122 59.7378 23.5262 59.8329 18.8181C59.928 14.11 53.5374 10.1627 45.5592 10.0016C37.5809 9.84048 31.0362 13.5265 30.9411 18.2346C30.8461 22.9427 37.2366 26.89 45.2149 27.0511Z",
    fill: "#CCD5FF"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 45,
    width: 20,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8009 45.5638H49.0815C48.3494 45.5638 47.7559 46.1573 47.7559 46.8894V49.4881C47.7559 50.2202 48.3494 50.8137 49.0815 50.8137H64.8009C65.533 50.8137 66.1265 50.2202 66.1265 49.4881V46.8894C66.1265 46.1573 65.533 45.5638 64.8009 45.5638Z",
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8009 45.5638H49.0815C48.3494 45.5638 47.7559 46.1573 47.7559 46.8894V49.4881C47.7559 50.2202 48.3494 50.8137 49.0815 50.8137H64.8009C65.533 50.8137 66.1265 50.2202 66.1265 49.4881V46.8894C66.1265 46.1573 65.533 45.5638 64.8009 45.5638Z",
    fill: "#D88532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.752 49.4784C49.752 50.2106 50.3455 50.8041 51.0776 50.8041H54.7425H54.3006C53.5684 50.8041 52.9749 50.2106 52.9749 49.4784V46.8935C52.9749 46.1614 53.5684 45.5679 54.3006 45.5679H54.7425H51.0776C50.3455 45.5679 49.752 46.1614 49.752 46.8935V49.4784Z",
    fill: "#EFBB6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4564 49.4963C66.4564 50.2285 65.8629 50.822 65.1307 50.822H47.5449V50.2299H60.1402C61.1164 50.2299 61.9077 49.4386 61.9077 48.4624V47.3334C61.9077 46.3572 61.1164 45.5658 60.1402 45.5658H65.1307C65.8629 45.5658 66.4564 46.1594 66.4564 46.8915V49.4963Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0293 46.2404H67.3198V45.425H47.8439L47.0293 46.2404Z",
    fill: "#EFBB6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 50,
    width: 19,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3634 50.8129H45.644C44.9119 50.8129 44.3184 51.4064 44.3184 52.1385V54.7372C44.3184 55.4693 44.9119 56.0628 45.644 56.0628H61.3634C62.0955 56.0628 62.689 55.4693 62.689 54.7372V52.1385C62.689 51.4064 62.0955 50.8129 61.3634 50.8129Z",
    fill: "#D9D9D9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3653 50.8129H45.646C44.9138 50.8129 44.3203 51.4064 44.3203 52.1385V54.7372C44.3203 55.4693 44.9138 56.0628 45.646 56.0628H61.3653C62.0974 56.0628 62.691 55.4693 62.691 54.7372V52.1385C62.691 51.4064 62.0974 50.8129 61.3653 50.8129Z",
    fill: "#D88532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3184 54.7277C46.3184 55.4598 46.9119 56.0533 47.644 56.0533H51.3088H50.867C50.1349 56.0533 49.5413 55.4598 49.5413 54.7277V52.1427C49.5413 51.4106 50.1349 50.817 50.867 50.817H51.3088H47.644C46.9119 50.817 46.3184 51.4106 46.3184 52.1427V54.7277Z",
    fill: "#EFBB6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0189 54.7453C63.0189 55.4775 62.4254 56.071 61.6932 56.071H44.1074V55.4789H56.7028C57.6789 55.4789 58.4703 54.6876 58.4703 53.7114V52.5824C58.4703 51.6062 57.6789 50.8148 56.7028 50.8148H61.6932C62.4254 50.8148 63.0189 51.4083 63.0189 52.1405V54.7453Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5898 51.4895H63.8804V50.6741H44.4045L43.5898 51.4895Z",
    fill: "#EFBB6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 56,
    width: 19,
    height: 6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3634 56.0669H45.644C44.9119 56.0669 44.3184 56.6604 44.3184 57.3926V59.9912C44.3184 60.7233 44.9119 61.3168 45.644 61.3168H61.3634C62.0955 61.3168 62.689 60.7233 62.689 59.9912V57.3926C62.689 56.6604 62.0955 56.0669 61.3634 56.0669Z",
    fill: "#D9D9D9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3653 56.0668H45.646C44.9138 56.0668 44.3203 56.6604 44.3203 57.3925V59.9911C44.3203 60.7233 44.9138 61.3168 45.646 61.3168H61.3653C62.0974 61.3168 62.691 60.7233 62.691 59.9911V57.3925C62.691 56.6604 62.0974 56.0668 61.3653 56.0668Z",
    fill: "#D88532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3184 59.9809C46.3184 60.7131 46.9119 61.3066 47.644 61.3066H51.3089H50.867C50.1349 61.3066 49.5414 60.7131 49.5414 59.9809V57.396C49.5414 56.6639 50.1349 56.0703 50.867 56.0703H51.3089H47.644C46.9119 56.0703 46.3184 56.6639 46.3184 57.396V59.9809Z",
    fill: "#EFBB6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0189 59.9993C63.0189 60.7315 62.4254 61.325 61.6932 61.325H44.1074V60.733H56.7028C57.6789 60.733 58.4703 59.9416 58.4703 58.9654V57.8364C58.4703 56.8602 57.6789 56.0688 56.7028 56.0688H61.6932C62.4254 56.0688 63.0189 56.6624 63.0189 57.3945V59.9993Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5898 56.7431H63.8804V55.9279H44.4045L43.5898 56.7431Z",
    fill: "#EFBB6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 61,
    width: 19,
    height: 6
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3634 61.3159H45.644C44.9119 61.3159 44.3184 61.9094 44.3184 62.6415V65.2401C44.3184 65.9723 44.9119 66.5658 45.644 66.5658H61.3634C62.0955 66.5658 62.689 65.9723 62.689 65.2401V62.6415C62.689 61.9094 62.0955 61.3159 61.3634 61.3159Z",
    fill: "#D9D9D9"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3653 61.3159H45.646C44.9138 61.3159 44.3203 61.9094 44.3203 62.6415V65.2401C44.3203 65.9723 44.9138 66.5658 45.646 66.5658H61.3653C62.0974 66.5658 62.691 65.9723 62.691 65.2401V62.6415C62.691 61.9094 62.0974 61.3159 61.3653 61.3159Z",
    fill: "#D88532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3184 65.2304C46.3184 65.9629 46.9119 66.5562 47.644 66.5562H51.3089H50.867C50.1349 66.5562 49.5414 65.9629 49.5414 65.2304V62.6455C49.5414 61.9134 50.1349 61.3199 50.867 61.3199H51.3089H47.644C46.9119 61.3199 46.3184 61.9134 46.3184 62.6455V65.2304Z",
    fill: "#EFBB6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0189 65.248C63.0189 65.9806 62.4254 66.5739 61.6932 66.5739H44.1074V65.9818H56.7028C57.6789 65.9818 58.4703 65.1905 58.4703 64.2144V63.0854C58.4703 62.1092 57.6789 61.3179 56.7028 61.3179H61.6932C62.4254 61.3179 63.0189 61.9114 63.0189 62.6435V65.248Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5898 61.9923H63.8804V61.1769H44.4045L43.5898 61.9923Z",
    fill: "#EFBB6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 40,
    width: 19,
    height: 6
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3634 40.3185H45.644C44.9119 40.3185 44.3184 40.9121 44.3184 41.6442V44.2428C44.3184 44.975 44.9119 45.5685 45.644 45.5685H61.3634C62.0955 45.5685 62.689 44.975 62.689 44.2428V41.6442C62.689 40.9121 62.0955 40.3185 61.3634 40.3185Z",
    fill: "#D9D9D9"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3653 40.3185H45.646C44.9138 40.3185 44.3203 40.9121 44.3203 41.6442V44.2428C44.3203 44.975 44.9138 45.5685 45.646 45.5685H61.3653C62.0974 45.5685 62.691 44.975 62.691 44.2428V41.6442C62.691 40.9121 62.0974 40.3185 61.3653 40.3185Z",
    fill: "#D88532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3184 44.2326C46.3184 44.9648 46.9119 45.5583 47.644 45.5583H51.3089H50.867C50.1349 45.5583 49.5414 44.9648 49.5414 44.2326V41.6476C49.5414 40.9155 50.1349 40.322 50.867 40.322H51.3089H47.644C46.9119 40.322 46.3184 40.9155 46.3184 41.6476V44.2326Z",
    fill: "#EFBB6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0189 44.251C63.0189 44.9832 62.4254 45.5767 61.6932 45.5767H44.1074V44.9846H56.7028C57.6789 44.9846 58.4703 44.1933 58.4703 43.2171V42.0881C58.4703 41.1119 57.6789 40.3205 56.7028 40.3205H61.6932C62.4254 40.3205 63.0189 40.9141 63.0189 41.6462V44.251Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5898 40.9951H63.8804V40.1798H44.4045L43.5898 40.9951Z",
    fill: "#EFBB6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 31,
    width: 19,
    height: 9
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5472 34.0354L49.0222 31.5712C48.2991 31.4564 47.6199 31.9496 47.5051 32.6727L47.0977 35.2392C46.983 35.9623 47.4761 36.6415 48.1992 36.7562L63.7242 39.2204C64.4473 39.3352 65.1265 38.842 65.2413 38.1189L65.6486 35.5524C65.7634 34.8294 65.2702 34.1501 64.5472 34.0354Z",
    fill: "#D9D9D9"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5472 34.0355L49.0222 31.5714C48.2991 31.4566 47.6199 31.9497 47.5051 32.6728L47.0977 35.2393C46.983 35.9624 47.4761 36.6416 48.1992 36.7564L63.7242 39.2206C64.4473 39.3353 65.1265 38.8422 65.2413 38.1191L65.6486 35.5526C65.7634 34.8295 65.2702 34.1503 64.5472 34.0355Z",
    fill: "#D88532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5472 34.0355L49.0222 31.5714C48.2991 31.4566 47.6199 31.9497 47.5051 32.6728L47.0977 35.2393C46.983 35.9624 47.4761 36.6416 48.1992 36.7564L63.7242 39.2206C64.4473 39.3353 65.1265 38.8422 65.2413 38.1191L65.6486 35.5526C65.7634 34.8295 65.2702 34.1503 64.5472 34.0355Z",
    fill: "#D88532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0752 35.5409C48.9604 36.2639 49.4535 36.9432 50.1766 37.0579L53.7962 37.6325L53.3597 37.5632C52.6367 37.4484 52.1435 36.7692 52.2583 36.0461L52.6635 33.4931C52.7783 32.7701 53.4575 32.2769 54.1806 32.3917L54.617 32.4609L50.9974 31.8864C50.2744 31.7717 49.5952 32.2648 49.4804 32.9879L49.0752 35.5409Z",
    fill: "#EFBB6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5632 38.1795C65.4484 38.9026 64.7692 39.3958 64.0461 39.281L46.6777 36.5243L46.7705 35.9395L59.2101 37.914C60.1742 38.067 61.0798 37.4094 61.2329 36.4453L61.4098 35.3303C61.5629 34.3662 60.9054 33.4605 59.9413 33.3075L64.8701 34.0898C65.5932 34.2046 66.0863 34.8838 65.9715 35.6069L65.5632 38.1795Z",
    fill: "#703307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8848 31.9189L66.9245 35.0996L67.0523 34.2944L47.8172 31.2413L46.8848 31.9189Z",
    fill: "#EFBB6E"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7015 45.3092L32.8379 66.5256L45.5844 67.415L45.4564 54.2653L44.2874 49.5095L35.7015 45.3092Z",
    fill: "#240544"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0484 44.4337C56.2734 44.785 55.2633 45.8039 54.9188 47.5664C54.5743 45.8097 53.5582 44.7792 51.7891 44.4396C53.5524 44.0941 54.5684 43.0753 54.9129 41.3069C55.2574 43.0635 56.2734 44.0941 58.0484 44.4396V44.4337Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.859 20.7129C28.0839 21.0643 27.0738 22.0831 26.7293 23.8455C26.3848 22.089 25.3688 21.0584 23.5996 20.7188C25.363 20.3734 26.379 19.3545 26.7235 17.5862C27.068 19.3428 28.0839 20.3734 29.859 20.7188V20.7129Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8173 12.8833C31.9608 13.0529 31.4734 13.5445 31.3071 14.395C31.1409 13.5473 30.6506 13.0501 29.7969 12.8862C30.6478 12.7195 31.1381 12.2279 31.3043 11.3745C31.4705 12.2222 31.9608 12.7195 32.8173 12.8862V12.8833Z",
    fill: "#AEBCFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6456 59.7634C23.722 63.2471 26.0291 65.9462 30.0204 66.4769C36.388 67.3537 43.1709 63.1779 45.2012 57.1333C46.3547 53.6727 44.6244 49.2661 42.894 46.1746L20.7383 58.1025L21.6456 59.7634Z",
    fill: "#7E3E30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1353_32975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 46,
    width: 26,
    height: 21
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6515 59.7821C23.7279 63.2661 26.035 65.9653 30.0262 66.496C36.3938 67.3727 43.1768 63.1966 45.207 57.1519C46.3606 53.6913 44.6302 49.2847 42.8999 46.1932L20.7441 58.1211L21.6515 59.7821Z",
    fill: "#7E3E30"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1353_32975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7717 51.3745C33.3042 45.5217 39.8413 42.7173 45.3726 45.1107C50.9039 47.5042 53.3349 54.1891 50.8024 60.0419C48.2698 65.8947 41.7328 68.6991 36.2014 66.3057C30.6701 63.9123 28.2391 57.2274 30.7717 51.3745Z",
    fill: "#D1674F"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0109 62.753C21.6433 61.8763 18.1134 56.247 20.1667 50.2024C22.2201 44.1578 29.026 39.9819 35.3936 40.8817C41.7381 41.7815 45.2449 47.3877 43.2147 53.4323C41.1845 59.4769 34.4016 63.6528 28.034 62.7761L28.0109 62.753Z",
    fill: "#FFC165"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5135 59.7882C26.2525 59.4652 24.4299 58.3578 23.3917 56.6736C22.3766 55.0125 22.2151 52.9592 22.9072 50.8828C23.6686 48.6449 25.3297 46.6377 27.5676 45.2765C29.8054 43.8923 32.3663 43.3155 34.7427 43.6616C37.0036 43.9845 38.8262 45.0919 39.8644 46.7992C40.8796 48.4603 41.0411 50.4906 40.3489 52.5901C39.5876 54.8279 37.9496 56.812 35.7116 58.1963C33.4737 59.5805 30.9129 60.1573 28.5366 59.8343L28.5135 59.7882Z",
    fill: "#FFE0B2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8937 56.3632L28.1309 53.0798H29.79C31.3715 53.021 33.0484 52.2745 33.3653 50.6119C33.5166 49.7983 33.6123 47.9439 31.167 47.9439",
    strokeWidth: 1.33285,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F0AD46"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0938 50.3845H35.1376",
    strokeWidth: 1.33285,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F0AD46"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.668 47.944L35.7695 47.9436",
    strokeWidth: 1.33285,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F0AD46"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1353_32975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 67.0526,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1353_32975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.7686,
    height: 67.0526,
    fill: "white",
    transform: "translate(19.1602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebt);
export default __webpack_public_path__ + "static/media/debt.5f2232a90ef3d1978c731957829a7381.svg";
export { ForwardRef as ReactComponent };